import { render, staticRenderFns } from "./GmbPhoto.vue?vue&type=template&id=4e5d8e24&scoped=true&"
import script from "./GmbPhoto.vue?vue&type=script&lang=js&"
export * from "./GmbPhoto.vue?vue&type=script&lang=js&"
import style0 from "./GmbPhoto.vue?vue&type=style&index=0&id=4e5d8e24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5d8e24",
  null
  
)

export default component.exports